export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7feeefab504644a6905a69894b09fe4d512024b719&name=fetchTypeahead!'